export default {
  props: {},
  data () {
    return {
      giftListByGoodId: [],
      checkGift: { type: '', value: null }
    }
  },
  computed: {},
  created () {
    // this.getVipTypeInfo() // 获取身份商品等级信息
  },
  methods: {
    centerModifyState () {
      this.dialog.visible = false
      const rQuery = this.$route.query
      const skuConLen = this.skuFormConfig.sku.length
      const checkGift = this.checkGift
      if (rQuery.type === 'edit') {
        if (checkGift.type === 'row') {
          // console.log(this.infoForm)
          for (let i = 0; i < skuConLen; i++) {
            if (this.skuFormConfig.sku[i].skuNo == checkGift.value.skuNo) {
              this.$set(this.skuFormConfig.sku[i], 'status', '1')
              this.$refs.skuForm.form.skuData[i].status = '1'
              break;
            }
          }
          this.$nextTick(() => { this.$forceUpdate() })
          console.log(this.skuFormConfig)
        } else {
          this.infoForm.status = this.dictionaries.sale_status[1].dictName
        }
        this.checkGift = { type: '', value: null }
        // this.$forceUpdate()
      }
      this.$forceUpdate()
    },
    submitModifyState () {
      const rQuery = this.$route.query
      this.dialog.visible = false
      if (rQuery.type !== 'edit') {
        const params = { ids: [] }
        const selectionGoods = this.selectionGoods
        if (selectionGoods.length > 0) {
          selectionGoods.forEach(e => { params.ids.push(e.id) })
        } else {
          params.ids.push(this.dialog.row.id)
        }
        const operationFun = this.$api.goodsPutOff
        operationFun(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }
      if (this.giftListByGoodId.length > 0) {
        this.onGiftPutOff()
      }
    },
    showModifyState (skuList, titleArr) {
      // console.log('showModifyState', skuList, titleArr)
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '下架提示'
      this.dialog.width = '640px'
      this.dialog.type = 'modifyState'
      // this.dialog.row = row
      this.dialog.titleArr = titleArr
      // this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    checkGoodsName (goodsName, goodsId) {
      return new Promise((resolve, reject) => {
        const params = { name: goodsName, id: goodsId }
        this.$api.isReapeatoodsName(params).then((res) => {
          // console.log(res)
          resolve(res)
        }).catch((err) => {
          // console.log(err)
          reject(err)
        })
      })
    },
    onChangeGoodsStatus (e) {
      this.checkGift = { type: '', value: null }
      const rQuery = this.$route.query
      const goodsId = rQuery.id
      const newVal = this.infoForm
      if (newVal && newVal.status && newVal.status.indexOf('下') > -1 && rQuery.type === 'edit') {
        // console.log(newVal.status, this.changeGoodsStatusNum)
        this.checkGiftListByGoodId([goodsId])
      }
    },
    checkGiftListByGoodId (ids, type) {
      const title = this.infoForm.name
      return new Promise((resolve, reject) => {
        this.$api.giftListByGoodId(ids).then((res) => {
          if (res.data.length > 0) {
            this.giftListByGoodId = res.data
            if (!type) {this.showModifyState(res.data, [title])}
          } else {
            // return this.onUpDownOperation(type, params, msg)
          }
          resolve(res.data)
        })
      })
    },
    onGiftPutOff (giftIds) {
      const ids = giftIds || []
      this.giftListByGoodId.forEach(e => { ids.push(e.id) })
      const params = { ids, status: 2 } // 状态（1-启用，2-禁用） 状态字典：enable_status

      if (giftIds) { params.ids = giftIds }

      return new Promise((resolve, reject) => {
        this.$api.giftPutOff(params).then((res) => {
          if (res.data.length > 0) {
            this.$message({ type: 'success', message: '操作成功!' })
            // return console.log(res)
          } else {
            // return console.log(res)
          }
          resolve(res.data)
        })
      })
    }
  }
}
